<template>
  <table class="table is-fullwidth is-bordered is-striped">
    <tbody>
      <tr v-for="folder in items.children" :key="folder.id">
        <td>
          <a
            v-if="$store.state.journal.folderBeingRenamed != folder.id"
            @click="toggleShow(folder.id)"
          >
            <span class="icon">
              <font-awesome-icon class="folder" :icon="FolderIcon(folder.id)" />
            </span>
            {{folder.name}}
          </a>
          <a
            v-if="$store.state.journal.folderBeingRenamed == folder.id && $store.state.folderBeingMoved == null"
          >
            <span class="icon">
              <font-awesome-icon class="folder" :icon="FolderIcon(folder.id)" />
            </span>
            <input
              class="input is-small rename-input"
              v-model="renamingName"
              type="text"
              v-on:keyup.enter="renameFolder(folder.id)"
            />
          </a>
          <div class="is-pulled-right">
            <a
              title="Confirm renaming"
              v-tippy
              v-if="$store.state.journal.folderBeingRenamed == folder.id"
              @click="renameFolder(folder.id)"
            >Confirm</a>
            <a
              v-if="!$store.state.journal.folderBeingMoved && $store.state.journal.folderBeingRenamed == null"
              @click="$store.dispatch('journal/createFolder',{FolderName:'New Folder',parentFolderId:folder.id})"
            >
              <span title="Make a new folder" v-tippy class="icon">
                <font-awesome-icon class="folder" :icon="'plus-square'" />
              </span>
            </a>
            <a
              title="Move this folder"
              v-tippy
              v-if="!$store.state.journal.folderBeingMoved && !$store.state.journal.movingFile && $store.state.journal.folderBeingRenamed == null"
              @click="$store.dispatch('journal/startMovingFolder', folder.id)"
            >
              <span class="icon">
                <font-awesome-icon icon="arrows-alt" />
              </span>
            </a>

            <a
              title="Cancel the folder movement"
              v-tippy
              v-if="$store.state.journal.folderBeingMoved && $store.state.journal.folderBeingMoved == folder.id"
              @click="cancelFolderMove()"
            >Cancel</a>

            <a
              v-if="!$store.state.journal.folderBeingMoved && $store.state.journal.folderBeingRenamed == null"
              @click="$store.dispatch('journal/startDeleting',folder.id)"
            >
              <span title="Delete folder" v-tippy class="icon">
                <font-awesome-icon class="folder" :icon="'minus-circle'" />
              </span>
            </a>
            <a
              v-if="!$store.state.journal.folderBeingMoved && $store.state.journal.folderBeingRenamed == null"
              @click="startRenamingFolder(folder.name,folder.id)"
            >
              <span title="Rename folder" v-tippy class="icon">
                <font-awesome-icon class="folder" :icon="'edit'" />
              </span>
            </a>
            <a
              title="Move the selected folder here"
              v-tippy
              v-if="$store.state.journal.folderBeingMoved && $store.state.journal.folderBeingMoved != folder.id"
              @click="moveItem(folder.id)"
            >Here</a>
            <a
              title="Move the selected file here"
              v-tippy
              v-if="$store.state.journal.movingFile"
              @click="$store.dispatch('journal/moveFile',folder.id)"
            >Here</a>
            <a
              title="Cancel renaming"
              v-tippy
              v-html=" ' Cancel'"
              v-if="$store.state.journal.folderBeingRenamed == folder.id"
              @click="$store.dispatch('journal/cancelRenamingFolder')"
            ></a>
          </div>
          <JournalItem
            v-show="$store.state.journal.openFolders.includes(folder.id)"
            :items="folder"
          />
        </td>
      </tr>
      <tr>
        <table
          v-if="items.documents.length>0"
          class="table is-fullwidth is-hoverable is-bordered is-striped"
        >
          <thead>
            <tr>
              <th>Document Name</th>
              <th>Updated At</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="document in items.documents" :key="document.id">
              <td>
                <a @click="goToDocument(document.id)">
                  <span class="icon is-small">
                    <img src="@/assets/img/icons/file.svg" />
                  </span>
                  {{document.name}}
                </a>
                <div class="is-pulled-right">
                  <a
                    title="Move this file"
                    v-tippy
                    v-if="!$store.state.journal.movingFile"
                    @click="$store.dispatch('journal/startMovingFile',document.id)"
                  >
                    <span class="icon">
                      <font-awesome-icon icon="arrows-alt" />
                    </span>
                  </a>
                  <a
                    title="Delete file"
                    v-tippy
                    v-if="!$store.state.journal.movingFile"
                    @click="$store.dispatch('journal/startDeletingFile',document.id)"
                  >
                    <span class="icon">
                      <font-awesome-icon class="folder" :icon="'minus-circle'" />
                    </span>
                  </a>
                  <a
                    title="Cancel the file movement"
                    v-tippy
                    v-if="$store.state.journal.fileBeingMoved == document.id"
                    @click="$store.dispatch('journal/stopMovingFile')"
                  >Cancel</a>
                </div>
              </td>
              <td>{{document.updated_at}}</td>
            </tr>
          </tbody>
        </table>
      </tr>
    </tbody>
  </table>
</template>

<script>
import BaseHelper from "@/helpers/BaseHelper";

export default {
  name: "JournalItem",
  mixins: [BaseHelper],
  data() {
    return { renamingName: "" };
  },
  components: {
    JournalItem: () => import("./JournalItem.vue")
  },
  props: {
    items: [Array, Object]
  },
  methods: {
    startRenamingFolder(name, id) {
      this.renamingName = name;
      this.$store.dispatch("journal/startRenamingFolder", id);
    },
    cancelFolderMove() {
      this.$store.dispatch("journal/cancelFolderMove");
    },
    moveItem(FolderId) {
      this.$store.dispatch("journal/chooseFolderTarget", FolderId);
      this.$store.dispatch("journal/moveFolder");
    },
    renameFolder(FolderId) {
      this.$store.dispatch("journal/renameFolder", this.renamingName);
      this.renamingName = "";
    },
    FolderIcon(FolderId) {
      if (this.$store.state.journal.openFolders.includes(FolderId)) {
        return "folder-open";
      } else {
        return "folder";
      }
    },
    toggleShow(FolderId) {
      this.$store.dispatch("journal/toggleOpenFolder", FolderId);
    }
  }
};
</script>
